import { Spinner } from "react-bootstrap";
import "./LoadingPlaceholder.css";

/**
 * Espaço reservado com brilho no lugar de um número que ainda está sendo calculado. Antes as
 * telas zeravam os valores durante a carga e mostravam "R$ 0,00", que o gestor lia como resultado.
 *
 * Nasceu na Visão do Negócio e é compartilhado com os demais painéis para todos carregarem do
 * mesmo jeito.
 *
 * @param {{width?: string, height?: string, className?: string}} props tamanho do valor que vai
 *        aparecer, para o cartão não mudar de altura quando o número chega
 */
export const Placeholder = ({ width = "60%", height = "1rem", className = "" }) => (
    <span className={`loading-skeleton ${className}`.trim()} style={{ width, height }} aria-hidden="true" />
);

/**
 * Carregamento de um painel inteiro. Ocupa o lugar do conteúdo, e não fica em cima dele: com o
 * aviso solto, o painel mostrava "Atualizando dados..." e logo abaixo "Sem movimentação", porque
 * os dados ainda estavam vazios. A altura é a do conteúdo que vai aparecer, para a tela não pular.
 *
 * @param {{height?: number, label?: string}} props
 */
export const PanelLoading = ({ height = 260, label = "Carregando dados..." }) => (
    <div className="panel-loading" style={{ minHeight: height }} role="status" aria-live="polite">
        <span className="loading-skeleton panel-loading__shimmer" aria-hidden="true" />
        <span className="panel-loading__label">
            <Spinner animation="border" size="sm" />
            {label}
        </span>
    </div>
);
